export default __webpack_public_path__ + "static/media/Arrow color.9e522008.svg";